import { Target, Eye, Crosshair, Clock, ShieldCheck, ListChecks } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

const ICONS = [Target, Eye, Crosshair, Clock, ShieldCheck, ListChecks];

export function WhyChoose() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].whyChoose;

  return (
    <section className="bg-ivory py-20 sm:py-28" data-testid="why-choose">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} sub={t.sub} />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {t.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={(i % 3) * 90}>
                <div className="group h-full rounded-3xl border border-navy/8 bg-white p-7 shadow-[0_2px_20px_-8px_rgba(15,27,61,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-16px_rgba(15,27,61,0.18)]">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                    <Icon className="h-[22px] w-[22px]" strokeWidth={1.8} />
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-semibold text-navy">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy/65">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
